"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const FontFamily_config_1 = require("./FontFamily.config");
function LanguageDropdown({ onSelect, localeSubsets, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const languageOptions = (0, react_1.useMemo)(() => localeSubsets.map((locale) => {
        return Object.assign(Object.assign({}, locale), { value: locale.name, label: locale.name === 'default'
                ? t('general.all')
                : FontFamily_config_1.localeLabel[locale.name] });
    }), []);
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { trigger: 'click', placement: 'rightTop', options: languageOptions, isClosedOnSelect: true, onClick: onSelect, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: 'outline', onClick: () => {
                return;
            }, icon: { name: 'globe' }, size: 'Small' }) }));
}
exports.LanguageDropdown = LanguageDropdown;
//# sourceMappingURL=LanguageDropdown.js.map